/*global addiesaas */

export const create = (componentName, options = {}) => {
  const vueInit = addiesaas.initSync
  const el = options.el

  const initOptions = {
    render(h) {
      return h(componentName, options)
    }
  }
  if (el) {
    initOptions.el = el
  }

  const vueApp = vueInit(initOptions)

  if (!el) {
    vueApp.$mount()
  }

  const instance = vueApp.$children[0]
  return instance
}
